import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ReservationService } from "../../services/reservation.service";
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/services/shared.service';
import * as moment from "moment-timezone";

@Component({
  selector: 'app-vtuber-reserve-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ReserveListComponent implements OnInit {
  reservations$: Observable<any>;

  constructor(
    public auth: AuthService,
    private rs: ReservationService,
    private shared: SharedService
  ) {}

  ngOnInit() {
    const source = this.rs.getReservationsQuery();
    this.reservations$ = this.rs.getReservations(source);
  }

  cancel(reservation) {
    this.shared.setCookie(SharedService.CURRENT_CANCEL_RESERVE, reservation);
    this.shared.redirect('/reserve/cancel/' + reservation.id);
  }

  canCancel(reservation) {
    if (moment(reservation.reserveAt + " " + reservation.start + ":00").toDate().getTime() < moment().tz('Asia/Tokyo')) return false;
    
    return reservation.status === 'reserved'
  }

}
